import { Maybe } from '@websky/graphql';

export const toMapById = <T extends { id?: Maybe<string> }>(items: Array<Maybe<T>>): Map<string, T> => {
	const map = new Map<string, T>();

	for (const item of items) {
		if (item?.id) {
			map.set(item.id, item);
		}
	}

	return map;
};
